import { CmsMarketingPreferencesForm } from './cms-marketing-preferences-form.interface';

export interface CmsMarketingPreferencesPage
  extends CmsMarketingPreferencesForm {
  pageTitle: string;
  pageSubtitle: string;
}
